import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {ParametersService, SubtitlesService, ZonesService} from "../../../core";
import {SimpleValveViewData} from "../../../models";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'simple-valve-card',
    templateUrl: './simple-valve-card.component.html',
    styleUrl: './simple-valve-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleValveCardComponent implements OnInit {
    private subtitlesService = inject(SubtitlesService);
    private zonesService = inject(ZonesService);
    private parameters = inject(ParametersService);
    private $state = inject(StateService);

    protected labels = {
        menu:     this.subtitlesService.setSubtitle(388),
        settings: this.subtitlesService.setSubtitle(3709),
    };

    ngOnInit(): void {
        if (this.zonesService.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.zonesService.setOverflow();
    }

    protected get selectedZone(): SimpleValveViewData {
        return this.zonesService.selectedZone as SimpleValveViewData;
    }

    protected get zoneName(): string {
        return this.zonesService.getZoneName(this.selectedZone);
    }

    protected get iconSrc(): string {
        return `/assets/img/zone_icons/light/${this.selectedZone?.description.styleIcon}.svg`;
    }

    protected get overflow(): boolean {
        return this.zonesService.overflow;
    }

    protected goHome(): void {
        this.zonesService.goHome();
    }

    protected goToMenu(): void {
        this.zonesService.goToMenu(this.selectedZone.tile, this.selectedZone.tile.submenuElementId);
    }

    protected goToInfo(): void {
        this.zonesService.goToState('simple_valve_info');
    }
}
